import { Actions } from './pdf-batch-generation.actions'
import { fromJS } from 'immutable'
import * as PdfBatchGenerationTypes from './pdf-batch-generation.types'

export const initialState = fromJS<any>({
  isLoading: false,
  isStatsLoading: false,
  validationErrors: {},
  stats: [],
  data: {},
})

export function pdfBatchGenerationReducer(
  state = initialState,
  action: Actions,
) {
  switch (action.type) {
    case PdfBatchGenerationTypes.FETCH_PDF_BATCH_STATS_REQUEST: {
      return state.set('isStatsLoading', true)
    }

    case PdfBatchGenerationTypes.FETCH_PDF_BATCH_STATS_SUCCESS: {
      return state
        .set('isStatsLoading', false)
        .set('stats', fromJS(action.payload))
    }

    case PdfBatchGenerationTypes.FETCH_PDF_BATCH_STATS_FAILURE: {
      return state.set('isStatsLoading', false)
    }

    case PdfBatchGenerationTypes.FETCH_PDF_BATCH_TASK_STATUS_REQUEST: {
      return state.set('isStatsLoading', true)
    }

    case PdfBatchGenerationTypes.FETCH_PDF_BATCH_TASK_STATUS_SUCCESS: {
      return state
        .set('isStatsLoading', false)
        .set('stats', fromJS(action.payload))
    }

    case PdfBatchGenerationTypes.FETCH_PDF_BATCH_TASK_STATUS_FAILURE: {
      return state.set('isStatsLoading', false)
    }

    case PdfBatchGenerationTypes.GENERATE_PDF_BATCH_REQUEST: {
      return state.set('isLoading', true)
    }
    case PdfBatchGenerationTypes.GENERATE_PDF_BATCH_SUCCESS: {
      return state.set('isLoading', false)
    }
    case PdfBatchGenerationTypes.GENERATE_PDF_BATCH_FAILURE: {
      return state.set('isLoading', false)
    }

    case PdfBatchGenerationTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case PdfBatchGenerationTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
